// extracted by mini-css-extract-plugin
export var hero = "PageHero-module--hero--tsvJO";
export var box = "PageHero-module--box--3x2kl";
export var about = "PageHero-module--about--22EmT";
export var contact = "PageHero-module--contact--1Nbmv";
export var services = "PageHero-module--services--3MvNs";